module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "Remind Setting",
      "closePage": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.label),
      expression: "label"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "label",
      "type": "text",
      "placeholder": "Label"
    },
    domProps: {
      "value": (_vm.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.label = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-2 col-form-label",
    attrs: {
      "id": "edit-reminder-frequence-picker"
    }
  }, [_vm._v("Frequence")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frequenceLabel),
      expression: "frequenceLabel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Choose frequence",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.frequenceLabel)
    },
    on: {
      "click": _vm.openFrequencePicker,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.frequenceLabel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("Remind method : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', {
    staticClass: "label-checkbox item-content form-check-inline"
  }, [_c('input', {
    staticClass: "checkboxApplicationMode",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.applicationMode
    },
    on: {
      "change": _vm.changeApplicationMode
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('label', {
    staticClass: "label-checkbox item-content form-check-inline"
  }, [_c('input', {
    staticClass: "checkboxEmailMode",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.emailMode
    },
    on: {
      "change": _vm.changeEmailMode
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('label', {
    staticClass: "label-checkbox item-content form-check-inline"
  }, [_c('input', {
    staticClass: "checkboxSmsMode",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.smsMode
    },
    on: {
      "change": _vm.changeSmsMode
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('button', {
    staticClass: "button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateRemindSetting()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-save"
  }), _vm._v(" "), _c('span', [_vm._v("Save")])]), _vm._v(" "), _c('button', {
    staticClass: "button-action refuse firstButtonMarginTop ",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteRemindSetting()
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-times-circle button-delete"
  }), _vm._v(" "), _c('span', [_vm._v("Delete")])])])]), _vm._v(" "), _vm._m(7)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('a', {
    staticClass: "item-link item-content",
    attrs: {
      "href": "/settings/remind/contactList/add/"
    }
  }, [_c('div', {
    staticClass: "item-inner col-form-label col-sm-12"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("Contact and contact group")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(" MoneyRoad")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(" Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v(" SMS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4fe38b7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe38b7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/CMEditRemindSetting.vue
// module id = 1673
// module chunks = 2